module.exports = __webpack_public_path__ + "img/مینیمال.fc0c1f59.png";